export enum HpmReportsHistoryMessages {
  ARCHIVE_LABEL = 'Archive',
  ARCHIVE_HEADING = 'Are you sure you want to archive the Hall Pass(es)',
}
